import React from 'react';
var BreadcrumbSkeleton = function (props) {
    var _a = props.count, count = _a === void 0 ? 3 : _a;
    var itemsArray = [];
    for (var i = 0; i < count; i++)
        itemsArray.push(i);
    return (React.createElement("section", { className: "container-fluid breadcrumbs" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-12" },
                React.createElement("ol", { className: "breadcrumb" }, itemsArray.map(function (key) { return (React.createElement("li", { className: "breadcrumb-item", key: key },
                    React.createElement("span", { className: "skeleton-line h-100 align-middle skeleton-w-sm d-inline-block" }))); }))))));
};
export default React.memo(BreadcrumbSkeleton);
